export const supportFileTypes = {
  TYPE_BACKUPS: "backups",
  TYPE_LOGS: "logs",
};
